import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { SearchProvider } from './context/SearchContext';
import { DetailDrawer } from './components/UI';
import { EntityDetailsProvider } from './context/EntityDetailsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import Parts from './pages/Parts';
import Equipment from './pages/Equipment';
import Orders from './pages/Orders';
import StockMovements from './pages/StockMovements';
import EquipmentTemplates from './pages/EquipmentTemplates';
import ComponentStock from './pages/ComponentStock';
import ProductionTasks from './pages/ProductionTasks';
import Vacations from './pages/Vacations';
import EquipmentReport from './pages/EquipmentReport';
import OrderPartsReport from './pages/OrderPartsReport';
import Repairs from './pages/Repairs';
import RepairReport from './pages/RepairReport';
import Customers from './pages/Customers';
import Dealers from './pages/Dealers';
import Devices from './pages/Devices';
import Users from './pages/Users';

function App() {
  return (
    <Provider store={store}>
      <LanguageProvider>
        <AuthProvider>
          <SearchProvider>
            <EntityDetailsProvider>
              <Router>
                <Routes>
                  {/* Public Route - Login */}
                  <Route path='/login' element={<Login />} />

                  {/* Protected Routes - Wrapped in Layout */}
                  <Route
                    path='/'
                    element={
                      <ProtectedRoute>
                        <Layout />
                      </ProtectedRoute>
                    }
                  >
                    <Route index element={<Dashboard />} />
                    <Route path='parts' element={<Parts />} />
                    <Route path='equipment' element={<Equipment />} />
                    <Route
                      path='equipment-templates'
                      element={<EquipmentTemplates />}
                    />
                    <Route
                      path='component-stock'
                      element={<ComponentStock />}
                    />
                    <Route
                      path='/equipment/report'
                      element={<EquipmentReport />}
                    />
                    <Route path='orders' element={<Orders />} />
                    <Route path='/orders/parts-report' element={<OrderPartsReport />} />
                    <Route path='stock-movements' element={<StockMovements />} />
                    <Route path='production-tasks' element={<ProductionTasks />} />
                    <Route path='vacations' element={<Vacations />} />
                    <Route path='repairs' element={<Repairs />} />
                    <Route path='repairs/:id' element={<RepairReport />} />
                    <Route path='customers' element={<Customers />} />
                    <Route path='dealers' element={<Dealers />} />
                    <Route path='devices' element={<Devices />} />
                    <Route
                      path='users'
                      element={
                        <ProtectedRoute adminOnly>
                          <Users />
                        </ProtectedRoute>
                      }
                    />
                  </Route>

                  {/* Catch all - redirect to home */}
                  <Route path='*' element={<Navigate to='/' replace />} />
                </Routes>

                {/* Global Detail Drawer - renders outside <Routes> but inside
                    <Router> so it can use navigation hooks (e.g. jumping from
                    a device's repair history to that ticket's page). */}
                <DetailDrawer />
              </Router>
            </EntityDetailsProvider>
          </SearchProvider>
        </AuthProvider>
      </LanguageProvider>
    </Provider>
  );
}

export default App;
